import { TabSliderOptionsProps } from "../../../../components/atoms/TabSlider/TabSlider";

export const MONTHS_LIST: TabSliderOptionsProps[] = [
  // { index: 0, title: "Januari", value: "January" },
  // { index: 1, title: "Februari", value: "February" },
  // { index: 2, title: "Maret", value: "March" },
  { index: 0, title: "April", value: "April" },
  { index: 1, title: "Mei", value: "May" },
  // { index: 2, title: "Juni", value: "June" },
  // { index: 3, title: "Juli", value: "July" },
  { index: 2, title: "Agustus", value: "August" },
  { index: 3, title: "September", value: "September" },
  { index: 4, title: "Oktober", value: "October" },
  // { index: 7, title: "November", value: "November" },
  // { index: 11, title: "Desember", value: "December" },
];
